import { InfoCard } from "../common/InfoCard"
import { ManualInputRow } from "../common/ManualInputRow"
import { PropertySetSelect } from "../common/PropertySetSelect"
import { UnitProps } from "../unitTypes"

export const SplitOtherTab = (props: UnitProps) => {
  const {data, unit} = props
  const splitterData = data?.units?.LIQUID_SPLITTER?.vars?.UNIT || {};
  const inletManifoldOutlet = data?.units?.INLET_MANIFOLD?.vars?.OUT || {};

  return <>
    <InfoCard title="Temperature Differences" className="mt-1">
      <ManualInputRow label="Inlet to Top" dimCode='DTEMP' data={splitterData?.DT_IN_TOP} attrKey=":LIQUID_SPLITTER:UNIT:DT_IN_TOP" unitId={unit.id}/>
      <ManualInputRow label="Inlet to Bottom" dimCode='DTEMP' data={splitterData?.DT_IN_BOTTOM} attrKey=":LIQUID_SPLITTER:UNIT:DT_IN_BOTTOM" unitId={unit.id}/>
      <ManualInputRow label="Top to Bottom" dimCode='DTEMP' data={splitterData?.DT_TOP_BOTTOM} attrKey=":LIQUID_SPLITTER:UNIT:DT_TOP_BOTTOM" unitId={unit.id}/>
      <ManualInputRow label="Mixer outlet Temperature" dimCode='TEMP' data={inletManifoldOutlet?.T} attrKey=":INLET_MANIFOLD:OUT:T" unitId={unit.id}/>
    </InfoCard>
    <ManualInputRow label="Heat Input"  dimCode='HEATFLOW' data={splitterData?.Q} attrKey=":LIQUID_SPLITTER:UNIT:Q" unitId={unit.id}/>
    <InfoCard title="Pressure Drops" className="mt-1">
      <ManualInputRow label="Inlet to Top" dimCode='DPRES' data={splitterData?.DP_IN_TOP} attrKey=":LIQUID_SPLITTER:UNIT:DP_IN_TOP" unitId={unit.id}/>
      <ManualInputRow label="Inlet to Bottom" dimCode='DPRES' data={splitterData?.DP_IN_BOTTOM} attrKey=":LIQUID_SPLITTER:UNIT:DP_IN_BOTTOM" unitId={unit.id}/>
      <ManualInputRow label="Top to Bottom" dimCode='DPRES' data={splitterData?.DP_TOP_BOTTOM} attrKey=":LIQUID_SPLITTER:UNIT:DP_TOP_BOTTOM" unitId={unit.id}/>
    </InfoCard>
    <PropertySetSelect unitId={unit.id} value={data?.args?.tpps} />
  </>
}